import { BrowserRouter, Link, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/AuthContext";
import FlyerPage from "@/FlyerPage";
import AuthPage from "@/AuthPage";
import MembersPage from "@/MembersPage";
import ResetPasswordPage from "@/ResetPasswordPage";

function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="app-header"
      className="w-full flex items-center justify-between px-5 py-3 border-b border-white/10 bg-[#04102e]"
    >
      <Link to="/" data-testid="brand-link" className="text-[#ffcd3c] font-bold tracking-wide">
        HOPE CDS <span className="text-white/70 font-normal">• Funding Flyer</span>
      </Link>
      {user === null ? (
        <span data-testid="auth-checking" className="text-blue-200/60 text-sm">
          Checking…
        </span>
      ) : user ? (
        <div className="flex items-center gap-3">
          <span data-testid="user-email" className="text-sm text-blue-100 hidden md:block">
            {user.email}
          </span>
          <Link
            data-testid="members-link"
            to="/members"
            className="text-sm rounded-full border border-[#ffcd3c] text-[#ffcd3c] px-4 py-1.5 hover:bg-[#ffcd3c]/10 transition"
          >
            Members
          </Link>
          <button
            data-testid="signout-btn"
            onClick={async () => {
              await logout();
              navigate("/");
            }}
            className="text-sm rounded-full border border-white/20 text-blue-100 px-4 py-1.5 hover:border-[#ffcd3c] hover:text-[#ffcd3c] transition"
          >
            Sign Out
          </button>
        </div>
      ) : (
        <Link
          data-testid="signin-link"
          to="/login"
          className="text-sm rounded-full bg-[#ffcd3c] text-[#0a1a3f] font-bold px-4 py-1.5 hover:brightness-110 transition"
        >
          Sign In
        </Link>
      )}
    </header>
  );
}

function AppInner() {
  return (
    <div className="min-h-screen bg-[#050e2a]">
      <Header />
      <Routes>
        <Route path="/" element={<FlyerPage />} />
        <Route path="/login" element={<AuthPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppInner />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
